import React, { useEffect, useState } from "react";
import classes from "./CoachAccountInfoSidebar.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { coachDemoImg } from "../../constant/imagePath";
import PropTypes from "prop-types";

export const CoachAccountInfoSidebar = ({
  userData,
  links,
  sidebarClassName,
  active,
}) => {
  return (
    <>
      {/* Styling */}
      <style jsx>{`
        .${classes.menuItemsBox} ul li {
          color: ${Colors.neutralShadesOfDimGray};
        }
      `}</style>

      <div
        className={`${[
          classes.sidebar,
          sidebarClassName && sidebarClassName,
        ].join(" ")}`}
        style={{
          backgroundColor: Colors.neutralShadesOfWhiteSmoke,
        }}
      >
        {/* Header */}
        <div
          className={classes.header}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        >
          <div>
            <img src={userData?.photo} className={classes.profile} />
          </div>
          <h6
            style={{
              ...Fonts.h7,
              lineHeight: "24px",
              fontFamily: "inter-600",
              color: Colors.neutralShadesOfNero,
            }}
          >
            {userData?.displayName}
          </h6>
        </div>
        {/* Menu Items */}
        <div className={classes.menuItemsBox}>
          {links?.map((item) => {
            return (
              <>
                <h6
                  style={{
                    ...Fonts.h6,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  {item?.heading}
                </h6>
                {/* Links */}
                <ul>
                  {item?.list?.map(({ title, onClick, activeText }) => {
                    return (
                      <li
                        onClick={onClick}
                        style={
                          active === activeText
                            ? {
                                ...Fonts.h7,
                                lineHeight: "24px",
                                fontFamily: "inter-600",
                                color: Colors.errorColor,
                              }
                            : { ...Fonts.p1 }
                        }
                        className={classes.active}
                      >
                        {title}
                      </li>
                    );
                  })}
                </ul>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

CoachAccountInfoSidebar.propTypes = {
  userData: PropTypes.object,
  sidebarClassName: PropTypes.string,
  active: PropTypes.string,
  links: PropTypes.array,
};

CoachAccountInfoSidebar.defaultProps = {
  userData: {
    photo: coachDemoImg,
    displayName: "John Johnson",
  },
  links: [
    {
      heading: "Edit Profile",
      list: [
        {
          title: "Personal info",
          activeText: "personal-info",
          onClick: () => console.log("clicked"),
        },
        {
          title: "Photo & Video",
          activeText: "photo-video",
          onClick: () => console.log("clicked"),
        },
        { title: "FAQ", onClick: () => console.log("clicked") },
      ],
    },
    {
      heading: "Edit Lesson Info",
      list: [
        {
          title: "Basic Info",
          activeText: "basic-info",
          onClick: () => console.log("clicked"),
        },
        {
          title: "What’s included",
          activeText: "what’s-included",
          onClick: () => console.log("clicked"),
        },
        {
          title: "Location",
          activeText: "location",
          onClick: () => console.log("clicked"),
        },
      ],
    },
    {
      heading: "Profile Settings",
      list: [
        {
          title: "Privacy settings",
          activeText: "privacy-settings",
          onClick: () => console.log("clicked"),
        },
        {
          title: "Payout methods",
          activeText: "payout-methods",
          onClick: () => console.log("clicked"),
        },
        {
          title: "Notifications",
          activeText: "notifications",
          onClick: () => console.log("clicked"),
        },
      ],
    },
  ],
  active: "personal-info",
};
